<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row" v-if="formData.benefit.action">
            <div class="col-12 col-lg-4">
                <div :class="['form-field form-field--currency',{'form-field--error':$v.formData.benefit.cost.$error}]">
                    <label for="benefitCost">{{ formLabels.fields.benefitCost }} <small>(Min £50, Max £250)</small></label>
                    <span>£</span><input v-model="formData.benefit.cost" id="benefitCost" step="1" min="50" max="250" @focusout="formatCost" type="number" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.benefitCost" v-tooltip="formTooltips.benefit.fields.benefitCost">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.cost.$error">This field is required</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { countDecimals } from '../../../../_helpers';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object
        }
    },
    inject: ['$v'],
    watch: {
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        benefitFields() {
            return this.formSummary[1].fields;
        }
    },
    methods: {
        formatCost() {
            let cost = this.formData.benefit.cost;

            if(cost > 250) {
                this.formData.benefit.cost = Number.parseInt(250).toFixed(0);
            } else if(cost < 50) {
                this.formData.benefit.cost = Number.parseInt(50).toFixed(0);
            } else {
                this.formData.benefit.cost = Number.parseFloat(cost).toFixed(0);
            }
        },
        setConditionals() {
            // We need to store the full object paths for use in the core form
            this.formConditionals.benefitCost = function() { return true }
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'Card action',
                    cost: 'Card value'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }
        },
    },
    mounted() {
        this.setConditionals();

        this.formSummary.push({
            fields: {}
        });
    }
}
</script>